export default "__VITE_PUBLIC_ASSET__ec225884__"